import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useEnvironment, useExperiments, usePanorama} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {FormStep} from '../../../constants'
import c from '../../classnames.scss'
import {FormSteps} from '../../form-steps'
import {Step} from '../../form-steps/interfaces'
import {RegistrationLayout} from '../../registration-layout'
import {Summary} from '../../summary'
import {Checkout} from '../index'
import {ReservationTimer} from '../reservation-timer'
import {DesktopCheckoutProps} from './interfaces'

export const DesktopCheckout = ({
  reservationExpiration,
  t,
  openTimeExpiredModal,
  formPageLoaded,
  closeNativeModal,
  scrollToElement,
}: DesktopCheckoutProps) => {
  const {logger} = usePanorama()
  const {isMobile} = useEnvironment()
  const {experiments} = useExperiments()

  React.useEffect(() => {
    formPageLoaded(true)
    closeNativeModal()
  }, [])

  return (
    <Checkout
      t={t}
      logger={logger}
      isMobile={isMobile}
      disabledButtonEnabled={experiments.enabled(ExperimentNames.DisabledButtonsViewer)}
    >
      {(steps: Step[], currentStep: FormStep) => (
        <div className={classNames(c.formBackgroundColor)}>
          <RegistrationLayout
            Left={<FormSteps currentStep={currentStep} steps={steps} t={t} scrollToElement={scrollToElement} />}
            Right={
              <>
                <ReservationTimer
                  expires={reservationExpiration}
                  onExpire={openTimeExpiredModal}
                  t={t}
                  isMobile={isMobile}
                />
                <Summary currentStep={currentStep} />
              </>
            }
          />
        </div>
      )}
    </Checkout>
  )
}
